import { Order } from 'types/OrderTypes';
import { Constants } from 'utils/Constants';
import { ProductType, JourneyLegType } from 'types/JourneyTypes';
import { configureOpenApiClients } from '../../api/configure';
import { seatMapGetAvailableSeats, seatReservationReserveSpecificSeats } from '../../api/v1';

export const useSeatingApi = (token: string, device: string, order: Order) => {
  configureOpenApiClients();

  const getAvailableSeats = async (data: { leg: JourneyLegType; product: ProductType }) => {
    return await seatMapGetAvailableSeats({
      path: { orderId: order.orderID },
      headers: { authorization: `Bearer ${token}` },
      query: {
        datedServiceJourneyId: data.leg.offerDatedServiceJourneyId,
        originId: data.leg.fromId,
        destinationId: data.leg.toId,
        seatTypeId: data.product.seatType,
        trainNumber: data.leg.trainNumber,
        imageWidth: device === Constants.DEVICE_SMALL ? 300 : 200,
        imageFormat: 'SVG',
      },
    });
  };

  const reserveSpecificSeats = async (args) =>
    await seatReservationReserveSpecificSeats({
      path: { orderId: order.orderID },
      body: args,
      headers: { authorization: `Bearer ${token}` },
    });

  return {
    getAvailableSeats,
    reserveSpecificSeats,
  };
};
